<p-dialog
  [(visible)]="modalVisible"
  [dismissableMask]="false"
  [draggable]="false"
  [modal]="true"
  [breakpoints]="{ '992px': '75vw', '640px': '90vw' }"
  [attr.data-e2e]="'form:buy-verification:modal'"
  [showHeader]="false"
  [contentStyleClass]="'clear_modal'"
  [closeOnEscape]="true"
  [closable]="true"
  transitionOptions="0ms"
>
  <ng-template pTemplate="content">
    <a
      href="javascript:void(0)"
      (click)="modalVisible = false"
      class="modal-close"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5 1.56818L14.4242 0.5L8 6.93182L1.56818 0.5L0.5 1.56818L6.93182 8L0.5 14.4242L1.56818 15.5L8 9.06818L14.4242 15.5L15.5 14.4242L9.06818 8L15.5 1.56818V1.56818Z"
          fill="white"
        />
      </svg>
    </a>
    <ng-container
      *ngTemplateOutlet="withSummary; context: { isModal: true }"
    ></ng-container>
  </ng-template>
</p-dialog>

<ng-template #buyButton let-checkModal="checkModal">
  <ng-container *ngIf="selectedPaymentMethod$ | async as selectedMethod">
    <div
      *ngIf="!checkModal && paymentLegalHint$ | async as paymentLegalHint"
      class="buy-button-legal-notice"
      [innerHTML]="paymentLegalHint"
    ></div>
    <div
      *ngIf="!checkModal && (isGift$ | async) === true"
      class="buy-button-legal-notice buy-button-order-gift-notice"
      i18n="@@buy_button.buy-verification.buy-button-order-gift-notice"
      >Die Bestellung ist ein Geschenk. Sie können nach der Zahlung eine
      Grußnachricht und das Datum für den Erhalt des Geschenks festlegen.
    </div>
    <div
      class="buy-button-container"
      *ngIf="
        selectedMethod.is_submit_button_visible ||
        selectedMethod.pay_method === 'alias'
      "
      [ngClass]="buyBtnTheme ? 'theme--' + buyBtnTheme : ''"
    >
      <div class="button-wrapper">
        <div class="brush"></div>
        <button
          [disabled]="buttonDisabled$ | async"
          (click)="submit(checkModal)"
          [attr.data-e2e]="'order:submit:button'"
          [class.ds-button]="buyBtnTheme === 'default'"
          [class.primary]="buyBtnTheme === 'default'"
        >
          <div class="button-icon-container left-icon" *ngIf="iconLeft">
            <i class="fa {{ iconLeft }}"></i>
          </div>
          <div class="button-inner">
            <span
              *ngIf="isTranslationMode; else buyButtonText"
              data-editor-target="btnText"
              data-editor-targetable
            >
              <span [innerHTML]="buyBtnText"></span>
            </span>
            <ng-template #buyButtonText>
              <span
                *ngIf="
                  (checkModal && (needToShowOrderSummaryBeforePurchase$ | async)
                    ? orderSummaryButtonTextIfNeeded$
                    : buttonText$
                  ) | async as text
                "
                [innerHTML]="text"
              >
              </span>
            </ng-template>
          </div>
          <div class="button-icon-container right-icon" *ngIf="iconRight">
            <i class="fa {{ iconRight }}"></i>
          </div>
        </button>
        <orderform-guarantee-seal
          *ngIf="sealType"
          [art]="sealType"
        ></orderform-guarantee-seal>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #withSummary let-isModal="isModal">
  <div
    class="pgb-style-outer-container"
    [ngClass]="summaryOuterContainerClasses"
  >
    <fieldset class="m-0" *ngIf="{ layout: summaryLayout } as tmp">
      <legend *ngIf="(isGift$ | async) === false">{{ modalTitle }}</legend>
      <legend *ngIf="(isGift$ | async) === true">{{ modalTitleAsGift }}</legend>

      <div
        class="d-flex d-flex--summary-container"
        [class.vertical-view]="tmp.layout === 'vertical'"
        [orderformBreakpoint]="
          tmp.layout === 'horizontal'
            ? { '700': 'vertical-view', '800': 'size-1-2' }
            : {}
        "
      >
        <div class="container-product-list">
          <orderform-product-list-mini
            (countProducts)="
              tmp.layout = $event <= 2 && isModal ? 'vertical' : summaryLayout
            "
          ></orderform-product-list-mini>
        </div>
        <div
          class="container-summary-button pgb-style-inner-container"
          [ngClass]="summaryInnerContainerClasses"
        >
          <orderform-order-summary></orderform-order-summary>
          <ng-container
            *ngTemplateOutlet="buyButton; context: { checkModal: false }"
          ></ng-container>
        </div>
      </div>
    </fieldset>
  </div>
</ng-template>

<ng-container *ngIf="(showSummary$ | async) === true">
  <ng-container *ngTemplateOutlet="withSummary"></ng-container>
</ng-container>

<ng-container *ngIf="!(showSummary$ | async)">
  <ng-container
    *ngTemplateOutlet="buyButton; context: { checkModal: true }"
  ></ng-container>
</ng-container>

<!-- Keep attention on edit classes, because these are used by pgb widget -->
